var _rect, _path, _rect2, _rect3, _rect4, _path2, _mask, _path3, _path4, _mask2, _path5, _path6, _rect5, _path7, _mask3, _path8, _path9, _path10, _path11, _path12, _mask4, _path13, _path14, _path15, _path16, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _path17, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.637001,
    y: 0.637001,
    width: 39.9933,
    height: 40.3585,
    rx: 6.15767,
    transform: "matrix(-1 0 0 1 54.4057 56.8057)",
    fill: "#E2E997",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7461 73.1377H31.4093C29.3454 73.1377 27.6722 74.8108 27.6722 76.8748V98.5234H32.7461V73.1377Z",
    fill: "#0C1119"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.637001,
    y: 0.637001,
    width: 117.961,
    height: 87.5759,
    rx: 3.77954,
    transform: "matrix(-1 0 0 1 149.429 70.5947)",
    fill: "#9F75DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.637001,
    y: 0.637001,
    width: 117.961,
    height: 87.5759,
    rx: 3.77954,
    transform: "matrix(-1 0 0 1 149.429 70.5947)",
    stroke: "#C4D9FF",
    strokeWidth: 1.274
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5879,
    y: 71.2881,
    width: 58.8119,
    height: 87.3267,
    rx: 3.56436,
    fill: "#4555D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9785 151.697L70.873 154.688C70.4217 155.908 69.4596 156.87 68.2393 157.322L65.252 158.429L63.6387 159.026L65.252 159.623L68.2393 160.729C69.4596 161.181 70.4217 162.144 70.873 163.364L71.9785 166.354L72.5762 167.971L73.1738 166.354L74.2793 163.364C74.7306 162.144 75.6929 161.181 76.9131 160.729L79.9004 159.623L81.5146 159.026L79.9004 158.429L76.9131 157.322C75.6929 156.87 74.7306 155.908 74.2793 154.688L73.1738 151.697L72.5762 150.081L71.9785 151.697Z",
    fill: "#0C1119",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_8505_8832",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8866 111.061C84.3044 109.787 82.5281 107.126 82.5281 104.051C82.5281 99.736 86.0235 96.2383 90.3353 96.2383C94.6472 96.2383 98.1426 99.736 98.1426 104.051C98.1426 107.079 96.42 109.706 93.9017 111.002L97.8833 132.348C98.1562 133.811 97.0336 135.162 95.5455 135.162H85.142C83.6489 135.162 82.5252 133.802 82.8064 132.336L86.8866 111.061Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8866 111.061C84.3044 109.787 82.5281 107.126 82.5281 104.051C82.5281 99.736 86.0235 96.2383 90.3353 96.2383C94.6472 96.2383 98.1426 99.736 98.1426 104.051C98.1426 107.079 96.42 109.706 93.9017 111.002L97.8833 132.348C98.1562 133.811 97.0336 135.162 95.5455 135.162H85.142C83.6489 135.162 82.5252 133.802 82.8064 132.336L86.8866 111.061Z",
    fill: "#0C1119"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8866 111.061L87.4504 109.919L88.3205 110.348L88.1378 111.301L86.8866 111.061ZM93.9017 111.002L92.6493 111.236L92.4755 110.303L93.3187 109.869L93.9017 111.002ZM97.8833 132.348L96.6309 132.582V132.582L97.8833 132.348ZM82.8064 132.336L81.5552 132.096V132.096L82.8064 132.336ZM83.8021 104.051C83.8021 106.623 85.2867 108.851 87.4504 109.919L86.3228 112.204C83.3222 110.723 81.2541 107.629 81.2541 104.051H83.8021ZM90.3353 97.5123C86.7279 97.5123 83.8021 100.439 83.8021 104.051H81.2541C81.2541 99.0331 85.3191 94.9643 90.3353 94.9643V97.5123ZM96.8686 104.051C96.8686 100.439 93.9428 97.5123 90.3353 97.5123V94.9643C95.3515 94.9643 99.4166 99.0331 99.4166 104.051H96.8686ZM93.3187 109.869C95.4291 108.783 96.8686 106.584 96.8686 104.051H99.4166C99.4166 107.575 97.411 110.628 94.4848 112.135L93.3187 109.869ZM96.6309 132.582L92.6493 111.236L95.1541 110.768L99.1357 132.114L96.6309 132.582ZM95.5455 133.888C96.2364 133.888 96.7576 133.261 96.6309 132.582L99.1357 132.114C99.5547 134.361 97.8308 136.436 95.5455 136.436V133.888ZM85.142 133.888H95.5455V136.436H85.142V133.888ZM84.0576 132.576C83.9271 133.257 84.4488 133.888 85.142 133.888V136.436C82.8491 136.436 81.1234 134.348 81.5552 132.096L84.0576 132.576ZM88.1378 111.301L84.0576 132.576L81.5552 132.096L85.6354 110.821L88.1378 111.301Z",
    fill: "#A1BEFF",
    mask: "url(#path-6-inside-1_8505_8832)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_8505_8832",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4076 98.4079H48.7971C52.5497 98.4079 55.5918 95.3658 55.5918 91.6132V70.5645H36.5036C33.6892 70.5645 31.4076 72.846 31.4076 75.6605V98.4079Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4076 98.4079V99.0449H30.7706V98.4079H31.4076ZM55.5918 70.5645V69.9275H56.2288V70.5645H55.5918ZM31.4076 97.7709H32.8567V99.0449H31.4076V97.7709ZM35.755 97.7709H38.6532V99.0449H35.755V97.7709ZM41.5515 97.7709H44.4497V99.0449H41.5515V97.7709ZM47.348 97.7709H48.7971V99.0449H47.348V97.7709ZM48.7971 97.7709C49.2092 97.7709 49.6112 97.7305 49.9996 97.6537L50.2468 98.9035C49.7774 98.9963 49.2926 99.0449 48.7971 99.0449V97.7709ZM52.218 96.7341C52.8898 96.2844 53.4683 95.7059 53.918 95.0341L54.9767 95.7428C54.4343 96.553 53.7369 97.2504 52.9267 97.7928L52.218 96.7341ZM54.8376 92.8157C54.9144 92.4273 54.9548 92.0253 54.9548 91.6132H56.2288C56.2288 92.1087 56.1802 92.5935 56.0874 93.0629L54.8376 92.8157ZM54.9548 91.6132V90.2977H56.2288V91.6132H54.9548ZM54.9548 87.6666V85.0355H56.2288V87.6666H54.9548ZM54.9548 82.4044V79.7733H56.2288V82.4044H54.9548ZM54.9548 77.1422V74.5111H56.2288V77.1422H54.9548ZM54.9548 71.88V70.5645H56.2288V71.88H54.9548ZM55.5918 71.2015H54.3988V69.9275H55.5918V71.2015ZM52.0128 71.2015H49.6267V69.9275H52.0128V71.2015ZM47.2407 71.2015H44.8547V69.9275H47.2407V71.2015ZM42.4687 71.2015H40.0826V69.9275H42.4687V71.2015ZM37.6966 71.2015H36.5036V69.9275H37.6966V71.2015ZM36.5036 71.2015C36.205 71.2015 35.9139 71.2307 35.6327 71.2863L35.3854 70.0366C35.7476 69.9649 36.1215 69.9275 36.5036 69.9275V71.2015ZM34.0266 71.9521C33.54 72.2779 33.121 72.6969 32.7953 73.1834L31.7366 72.4747C32.155 71.8497 32.6929 71.3118 33.3178 70.8935L34.0266 71.9521ZM32.1295 74.7895C32.0739 75.0707 32.0446 75.3618 32.0446 75.6605H30.7706C30.7706 75.2784 30.8081 74.9044 30.8797 74.5423L32.1295 74.7895ZM32.0446 75.6605V77.0822H30.7706V75.6605H32.0446ZM32.0446 79.9256V82.769H30.7706V79.9256H32.0446ZM32.0446 85.6125V88.4559H30.7706V85.6125H32.0446ZM32.0446 91.2993V94.1428H30.7706V91.2993H32.0446ZM32.0446 96.9862V98.4079H30.7706V96.9862H32.0446ZM31.4076 98.4079V99.6819H30.1336V98.4079H31.4076ZM55.5918 70.5645V69.2905H56.8658V70.5645H55.5918ZM31.4076 97.1339H32.8567V99.6819H31.4076V97.1339ZM35.755 97.1339H38.6532V99.6819H35.755V97.1339ZM41.5515 97.1339H44.4497V99.6819H41.5515V97.1339ZM47.348 97.1339H48.7971V99.6819H47.348V97.1339ZM48.7971 97.1339C49.1675 97.1339 49.5281 97.0976 49.8759 97.0288L50.3704 99.5284C49.8606 99.6292 49.3344 99.6819 48.7971 99.6819V97.1339ZM51.8636 96.2048C52.4662 95.8014 52.9853 95.2823 53.3887 94.6797L55.506 96.0972C54.9173 96.9766 54.1605 97.7334 53.2811 98.3221L51.8636 96.2048ZM54.2127 92.6921C54.2815 92.3442 54.3178 91.9836 54.3178 91.6132H56.8658C56.8658 92.1505 56.8131 92.6767 56.7122 93.1865L54.2127 92.6921ZM54.3178 91.6132V90.2977H56.8658V91.6132H54.3178ZM54.3178 87.6666V85.0355H56.8658V87.6666H54.3178ZM54.3178 82.4044V79.7733H56.8658V82.4044H54.3178ZM54.3178 77.1422V74.5111H56.8658V77.1422H54.3178ZM54.3178 71.88V70.5645H56.8658V71.88H54.3178ZM55.5918 71.8385H54.3988V69.2905H55.5918V71.8385ZM52.0128 71.8385H49.6267V69.2905H52.0128V71.8385ZM47.2407 71.8385H44.8547V69.2905H47.2407V71.8385ZM42.4687 71.8385H40.0826V69.2905H42.4687V71.8385ZM37.6966 71.8385H36.5036V69.2905H37.6966V71.8385ZM36.5036 71.8385C36.2467 71.8385 35.997 71.8636 35.7563 71.9112L35.2618 69.4117C35.6645 69.332 36.0798 69.2905 36.5036 69.2905V71.8385ZM34.3809 72.4815C33.9636 72.7609 33.604 73.1204 33.3246 73.5378L31.2073 72.1203C31.672 71.4262 32.2693 70.8288 32.9634 70.3641L34.3809 72.4815ZM32.7544 74.9132C32.7068 75.1538 32.6816 75.4036 32.6816 75.6605H30.1336C30.1336 75.2367 30.1752 74.8213 30.2548 74.4187L32.7544 74.9132ZM32.6816 75.6605V77.0822H30.1336V75.6605H32.6816ZM32.6816 79.9256V82.769H30.1336V79.9256H32.6816ZM32.6816 85.6125V88.4559H30.1336V85.6125H32.6816ZM32.6816 91.2993V94.1428H30.1336V91.2993H32.6816ZM32.6816 96.9862V98.4079H30.1336V96.9862H32.6816Z",
    fill: "#A5C1FF",
    mask: "url(#path-8-inside-2_8505_8832)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.957 139.138H48.0253C50.0893 139.138 51.7624 140.811 51.7624 142.875V159.446H47.957V139.138Z",
    fill: "#0C1119"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.637001,
    y: 0.637001,
    width: 32.5516,
    height: 32.4043,
    rx: 3.4398,
    transform: "matrix(-1 0 0 1 46.9682 136.697)",
    fill: "#FFC37D",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.282 115.592C139.192 115.592 130.2 124.588 130.2 135.687C130.2 146.785 139.192 155.781 150.282 155.781C161.372 155.781 170.363 146.785 170.363 135.687C170.363 124.588 161.372 115.592 150.282 115.592Z",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-3_8505_8832",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.376 156.414C150.607 155.922 150.736 155.372 150.736 154.793V114.956C150.586 114.953 150.435 114.951 150.284 114.951C138.841 114.951 129.566 124.233 129.566 135.683C129.566 147.133 138.841 156.414 150.284 156.414C150.315 156.414 150.345 156.414 150.376 156.414Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.376 156.414C150.607 155.922 150.736 155.372 150.736 154.793V114.956C150.586 114.953 150.435 114.951 150.284 114.951C138.841 114.951 129.566 124.233 129.566 135.683C129.566 147.133 138.841 156.414 150.284 156.414C150.315 156.414 150.345 156.414 150.376 156.414Z",
    fill: "#FF7D7D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.376 156.414L151.53 156.955L151.187 157.685L150.382 157.688L150.376 156.414ZM150.736 114.956L150.764 113.682L152.01 113.709V114.956H150.736ZM149.223 155.873C149.376 155.547 149.462 155.182 149.462 154.793H152.01C152.01 155.563 151.838 156.297 151.53 156.955L149.223 155.873ZM149.462 154.793V114.956H152.01V154.793H149.462ZM150.709 116.23C150.568 116.227 150.426 116.225 150.284 116.225V113.677C150.444 113.677 150.604 113.679 150.764 113.682L150.709 116.23ZM150.284 116.225C139.546 116.225 130.84 124.936 130.84 135.683H128.292C128.292 123.53 138.137 113.677 150.284 113.677V116.225ZM130.84 135.683C130.84 146.43 139.546 155.14 150.284 155.14V157.688C138.137 157.688 128.292 147.835 128.292 135.683H130.84ZM150.284 155.14C150.313 155.14 150.342 155.14 150.371 155.14L150.382 157.688C150.349 157.688 150.316 157.688 150.284 157.688V155.14Z",
    fill: "#A5C1FF",
    mask: "url(#path-13-inside-3_8505_8832)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4258 7.52246C74.5715 7.52247 61.7188 20.3752 61.7188 36.2295V71.0664H119.133V36.2295C119.133 20.3752 106.28 7.52246 90.4258 7.52246Z",
    fill: "white",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4062 24.1064C83.9861 24.1064 78.7813 29.3113 78.7812 35.7314V71.0654H102.031V35.7314C102.031 29.3113 96.8264 24.1065 90.4062 24.1064Z",
    fill: "#0C1119",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9365 33.1641C72.5634 33.1641 67.3955 38.3346 67.3955 44.7129C67.3957 51.0909 72.5636 56.2607 78.9365 56.2607C85.3093 56.2605 90.4763 51.0908 90.4766 44.7129C90.4766 38.3348 85.3094 33.1643 78.9365 33.1641Z",
    stroke: "#ADC7FF",
    strokeWidth: 1.274
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-4_8505_8832",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.599 32.523C78.3242 33.5428 78.1776 34.6151 78.1776 35.7218V56.8659C78.4265 56.8811 78.6774 56.8888 78.9302 56.8888C85.6555 56.8888 91.1074 51.4334 91.1074 44.7037C91.1074 37.974 85.6555 32.5186 78.9302 32.5186C78.8194 32.5186 78.709 32.52 78.599 32.523Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.599 32.523C78.3242 33.5428 78.1776 34.6151 78.1776 35.7218V56.8659C78.4265 56.8811 78.6774 56.8888 78.9302 56.8888C85.6555 56.8888 91.1074 51.4334 91.1074 44.7037C91.1074 37.974 85.6555 32.5186 78.9302 32.5186C78.8194 32.5186 78.709 32.52 78.599 32.523Z",
    fill: "#7DDFBB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.599 32.523L77.3689 32.1915L77.6159 31.2748L78.565 31.2494L78.599 32.523ZM78.1776 56.8659L78.1 58.1376L76.9036 58.0646V56.8659H78.1776ZM79.8291 32.8545C79.5832 33.7672 79.4516 34.7281 79.4516 35.7218H76.9036C76.9036 34.5022 77.0652 33.3184 77.3689 32.1915L79.8291 32.8545ZM79.4516 35.7218V56.8659H76.9036V35.7218H79.4516ZM78.2552 55.5943C78.4783 55.6079 78.7033 55.6148 78.9302 55.6148V58.1628C78.6516 58.1628 78.3747 58.1543 78.1 58.1376L78.2552 55.5943ZM78.9302 55.6148C84.9511 55.6148 89.8334 50.7305 89.8334 44.7037H92.3814C92.3814 52.1362 86.3599 58.1628 78.9302 58.1628V55.6148ZM89.8334 44.7037C89.8334 38.6769 84.9511 33.7926 78.9302 33.7926V31.2446C86.3599 31.2446 92.3814 37.2712 92.3814 44.7037H89.8334ZM78.9302 33.7926C78.8308 33.7926 78.7317 33.7939 78.633 33.7965L78.565 31.2494C78.6864 31.2462 78.8081 31.2446 78.9302 31.2446V33.7926Z",
    fill: "#A6C1FF",
    mask: "url(#path-18-inside-4_8505_8832)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.693 90.6709L149.303 91.7246C148.851 92.945 147.889 93.9077 146.669 94.3594L145.614 94.75L144 95.3467L145.614 95.9443L146.669 96.335C147.889 96.7866 148.851 97.7486 149.303 98.9688L149.693 100.023L150.291 101.638L150.888 100.023L151.278 98.9688C151.73 97.7484 152.693 96.7866 153.913 96.335L154.967 95.9443L156.582 95.3467L154.967 94.75L153.913 94.3594C152.693 93.9077 151.73 92.9451 151.278 91.7246L150.888 90.6709L150.291 89.0557L149.693 90.6709Z",
    fill: "#0D121A",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7314 3.70117L89.3564 4.71484C88.9051 5.93542 87.9431 6.89773 86.7227 7.34961L85.7109 7.72461L84.0977 8.32227L85.7109 8.91895L86.7227 9.29395C87.9431 9.74583 88.9051 10.7091 89.3564 11.9297L89.7314 12.9434L90.3291 14.5586L90.9268 12.9434L91.3018 11.9297C91.7531 10.7091 92.7151 9.74583 93.9355 9.29395L94.9473 8.91895L96.5615 8.32227L94.9473 7.72461L93.9355 7.34961C92.7152 6.89771 91.7531 5.93543 91.3018 4.71484L90.9268 3.70117L90.3291 2.08496L89.7314 3.70117Z",
    fill: "#090D14",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 118.76)",
    fill: "#A3BFFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.564 121.304)",
    fill: "#A3BFFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.565 117.48)",
    fill: "#A3BFFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 122.566)",
    fill: "#A3BFFF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.564 125.108)",
    fill: "#A3BFFF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 123.829)",
    fill: "#A3BFFF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 164.17 122.566)",
    fill: "#AAC5FF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 120.021)",
    fill: "#A3BFFF"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 126.37)",
    fill: "#A3BFFF"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.565 128.913)",
    fill: "#A3BFFF"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 127.634)",
    fill: "#A3BFFF"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 164.17 126.37)",
    fill: "#AAC5FF"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 130.177)",
    fill: "#A3BFFF"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.565 132.719)",
    fill: "#A3BFFF"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 131.456)",
    fill: "#A3BFFF"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 164.17 130.177)",
    fill: "#AAC5FF"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 167.959 128.913)",
    fill: "#AAC5FF"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 133.981)",
    fill: "#A3BFFF"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.564 136.524)",
    fill: "#A3BFFF"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 135.261)",
    fill: "#A3BFFF"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 164.17 133.981)",
    fill: "#AAC5FF"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 167.959 132.72)",
    fill: "#AAC5FF"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 137.786)",
    fill: "#A3BFFF"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.564 140.328)",
    fill: "#A3BFFF"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 139.066)",
    fill: "#A3BFFF"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 164.17 137.786)",
    fill: "#AAC5FF"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 167.959 136.524)",
    fill: "#AAC5FF"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 141.609)",
    fill: "#A3BFFF"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.564 144.133)",
    fill: "#A3BFFF"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 142.871)",
    fill: "#A3BFFF"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 164.17 141.609)",
    fill: "#AAC5FF"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 167.959 140.328)",
    fill: "#AAC5FF"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 145.414)",
    fill: "#A3BFFF"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.564 147.957)",
    fill: "#A3BFFF"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 156.564 151.762)",
    fill: "#A3BFFF"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 146.676)",
    fill: "#A3BFFF"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 164.17 145.414)",
    fill: "#AAC5FF"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 160.354 150.48)",
    fill: "#A3BFFF"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 149.219)",
    fill: "#A3BFFF"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 152.744 153.023)",
    fill: "#A3BFFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.282 115.592C139.192 115.592 130.2 124.588 130.2 135.687C130.2 146.785 139.192 155.781 150.282 155.781C161.372 155.781 170.363 146.785 170.363 135.687C170.363 124.588 161.372 115.592 150.282 115.592Z",
    stroke: "#A5C1FF",
    strokeWidth: 1.274
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 77.1543 35.0605)",
    fill: "#A5C1FF"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 74.6309 36.3223)",
    fill: "#A5C1FF"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 72.0723 38.8652)",
    fill: "#A5C1FF"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 69.5488 43.9502)",
    fill: "#A5C1FF"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 77.1543 38.8652)",
    fill: "#A5C1FF"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 74.6309 40.1465)",
    fill: "#A5C1FF"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 72.0723 42.6709)",
    fill: "#A5C1FF"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 69.5488 47.7549)",
    fill: "#A5C1FF"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 77.1543 42.6709)",
    fill: "#A5C1FF"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 74.6309 43.9502)",
    fill: "#A5C1FF"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 72.0723 46.4756)",
    fill: "#A5C1FF"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 77.1543 46.4756)",
    fill: "#A5C1FF"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 74.6309 47.7549)",
    fill: "#A5C1FF"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 72.0723 50.2979)",
    fill: "#A5C1FF"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 77.1543 50.2979)",
    fill: "#A5C1FF"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 74.6309 51.5596)",
    fill: "#A5C1FF"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.634231,
    cy: 0.634642,
    rx: 0.634231,
    ry: 0.634642,
    transform: "matrix(-1 0 0 1 77.1543 54.1025)",
    fill: "#A5C1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secureIcon.f5aafa1ba7c882cec5e93df59d488c4e.svg";
export { ForwardRef as ReactComponent };